<div *ngIf="type==1">
<div class=" border" *ngIf="spec!=null">
    <div class="padding-10 backg" fxLayout="row">
      <b class="f20">{{title}}
      </b>
    </div>
    <mat-divider></mat-divider>
    <div>
      <div class="backg">
        <div>

            <table id="details">
                <tr *ngFor="let item of spec | keyvalue">
                  <td  class="color-gray">
                    {{item.key}}
                  </td>
                  <td>
                    
                    <p class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                  </td>
                </tr>
              </table>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="type==2">
  <div  *ngIf="spec!=null">
      <div class="padding-10 backg" fxLayout="row">
        <b class="f20">{{title}}
        </b>
      </div>
      <div>
        <div class="backg">
          <div>
              <table id="details">
                  <tr *ngFor="let item of spec | keyvalue">
                    <td  class="color-gray">
                      {{item.key}}
                    </td>
                    <td>                      
                      <p class="blackColor wordBreak" [innerHTML]="item.value"> </p>
                    </td>
                  </tr>
                </table>
          </div>
        </div>
      </div>
    </div>
  </div>